var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModelYMD',{attrs:{"label":_vm.label,"ymd":_vm.ymd,"valid":_vm.valid,"year-input-type":_vm.yearInputType,"max-year":_vm.maxYear,"min-year":_vm.minYear,"validator":_vm.validator,"show-errors":_vm.showErrors,"disableInputs":_vm.disable,"hidden-lenght-counter":_vm.hiddenLenghtCounter},on:{"change":_vm.emit}})
}
var staticRenderFns = []

export { render, staticRenderFns }